export default "__VITE_ASSET__DdN0P819__"